import React from "react";
//#region types
import { DashboardLayoutProps } from "models/propTypes/pageLayoutPropTypes";
//#endregion
//#region components
import DashboardBreadCrumb from "../breadCrumbs/dashboardBreadCrumb";
import FilterSelection from "../filter/filterSelection";
import FilterWrapper from "../filter/filterWrapper";
import GridR from "../grid/responsiveGrid";
import { Grid } from "@mui/material";
import { ErrorView } from "components/error";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

function DashboardLayout<FilterType extends Record<string, any>>(
  props: React.PropsWithChildren<DashboardLayoutProps<FilterType>>
) {
  const {
    hasPermissions,
    topRightButtons,
    title,
    filterFields,
    validationSchema,
    initialFilter,
    breadCrumb,
    filterValueFormatter,
    filterQueryStateHandler,
    entityKey,
    filterCategory,
    reportToAPIFilterFormatter,
    apiToReportFilterFormatter,
    footer,
    className,
    onClickClearAll,
  } = props;

  const content = (
    <Grid
      container
      className={clsx(cssExports.dashboardPanel, className, footer ? cssExports.fullHeight : undefined)}
      spacing={2}
    >
      <Grid container item className={cssExports.caption}>
        {breadCrumb ?? <DashboardBreadCrumb />}
      </Grid>
      <Grid container item className={cssExports.dashboardTitleContainer}>
        <Grid container spacing={1}>
          <Grid container item direction="row">
            <Grid item xs>
              {typeof title === "string" ? (
                <Grid item className={cssExports.dashboardHeaderText}>
                  {title}
                </Grid>
              ) : (
                title
              )}
            </Grid>
            <Grid item>{topRightButtons}</Grid>
          </Grid>
          {filterFields && (
            <Grid container item>
              <FilterSelection filterFields={filterFields} onClickClearAll={onClickClearAll} />
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid container item className={cssExports.dashboardContentContainer}>
        <GridR container spacing={4} key={entityKey}>
          {props.children}
        </GridR>
      </Grid>

      <Grid id="reportFooterContainer" container item className={cssExports.footerContainer}>
        {footer}
      </Grid>
    </Grid>
  );

  return hasPermissions === false ? (
    <ErrorView />
  ) : filterFields ? (
    <FilterWrapper
      initialFilter={initialFilter}
      filterFields={filterFields}
      valueFormatter={filterValueFormatter}
      filterQueryStateHandler={filterQueryStateHandler}
      filterCategory={filterCategory}
      reportToAPIFilterFormatter={reportToAPIFilterFormatter}
      apiToReportFilterFormatter={apiToReportFilterFormatter}
      validationSchema={validationSchema}
    >
      {content}
    </FilterWrapper>
  ) : (
    content
  );
}

export default DashboardLayout;
